import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { DocumentoRiproduzioneRow } from 'src/app/shared/models/documentoRiproduzione.model';

@Component({
  selector: 'app-riproduzioni-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-table [value]="riproduzioni()" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th class="col-w50">Stato</th>
          <th class="col-w120">Numero d'ordine</th>
          <th class="col-w120">Posizione</th>
          <th class="col-w70">Protocollo</th>
          <th class="col-w120">N° richiesta</th>
          <th class="col-w120">Richiedente</th>
          <th class="col-w120">Data richiesta</th>
          <th class="col-w40"></th>
          <th class="col-w40"></th>
          <th class="col-w40"></th>
          <th class="col-w40"></th>
          <th class="col-w40"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-riproduzione>
        <tr>
          <td class="col-w50">
            <div [ngClass]="{circle:true}" [style.background-color]="rowColor(riproduzione)"
             [pTooltip]="riproduzione.stato" tooltipPosition="top">
            </div>
          </td>
          <td class="col-w120">{{ riproduzione.numeroOrdine }}</td>
          <td class="col-w120">
            <app-position-value [posizione]="riproduzione.posizione"></app-position-value>
          </td>
          <td class="col-w90">{{ riproduzione.protocollo }}</td>
          <td class="col-w120">{{ riproduzione.numeroRichiesta }}</td>
          <td class="col-w120">{{ riproduzione.enteRichiedente }}</td>
          <td class="col-w120">{{ riproduzione.dataRichiesta | dataStorico }}</td>

          @if (riproduzione.documentoRiproduzioneId && riproduzione.trasmesso) {
            <!-- Buttons riproduzione trasmessa -->
            <td class="col-w40">
            <p-button pTooltip="Apri Documento" tooltipPosition="top" icon="fas fa-share-square fa-lg" styleClass="p-button-text" (click)="vaiADocumento(riproduzione.documentoRiproduzioneId)"></p-button>
            </td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
          }
          @else if (riproduzione.documentoRiproduzioneId && !riproduzione.trasmesso && !riproduzione.distrutto && !riproduzione.spedito) {
            <!-- Buttons riproduzione non trasmessa -->
            <td class="col-w40">
              <p-button pTooltip="Trasmetti con protocollo" tooltipPosition="top" icon="fas fa-paper-plane fa-lg" styleClass="p-button-text" (click)="trasmettiRiproduzione(riproduzione)"></p-button>
            </td>
            <td class="col-w40">
              <p-button pTooltip="Spedisci senza protocollare" tooltipPosition="top" icon="fas fa-envelope fa-lg" styleClass="p-button-text" (click)="spedisciRiproduzione(riproduzione)"></p-button>
            </td>
            <td class="col-w40">
              <p-button pTooltip="Gestisci allegati" tooltipPosition="top" icon="fas fa-paperclip fa-lg"  styleClass="p-button-text p-button-warning" (click)="gestisciAllegatiRipoduzione(riproduzione)"></p-button>
            </td>
            <td class="col-w40">
              <p-button pTooltip="Modifica" tooltipPosition="top" icon="fas fa-edit fa-lg"  styleClass="p-button-text" (click)="modificaRipoduzione(riproduzione)"></p-button>
            </td>
            <td class="col-w40">
              <p-button  pTooltip="Distruggi" tooltipPosition="top" icon="fas fa-trash fa-lg" color="red" styleClass="p-button-text p-button-danger"  (click)="distruggiRiproduzione(riproduzione)"></p-button>
            </td>
          }
          @else if (!riproduzione.documentoRiproduzioneId && !riproduzione.distrutto) {
            <!-- Buttons doc originale -->
            <td class="col-w40">
              <p-button pTooltip="Apri Documento" tooltipPosition="top" icon="fas fa-share-square fa-lg" styleClass="p-button-text" (click)="vaiADocumento(riproduzione.documentoId)"></p-button>
            </td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
          }
          @else if (riproduzione.spedito && !riproduzione.distrutto) {
            <td class="col-w40">
              <p-button pTooltip="Apri Documento" tooltipPosition="top" icon="fas fa-share-square fa-lg" styleClass="p-button-text" (click)="vaiADocumento(riproduzione.documentoRiproduzioneId)"></p-button>
            </td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
            <td class="col-w40"> <p-button  pTooltip="Distruggi" tooltipPosition="top" icon="fas fa-trash fa-lg" color="red" styleClass="p-button-text p-button-danger"  (click)="distruggiRiproduzione(riproduzione)"></p-button></td>
          }
          @else {
            <td class="col-w40">
              <p-button pTooltip="Apri Documento" tooltipPosition="top" icon="fas fa-share-square fa-lg" styleClass="p-button-text" (click)="vaiADocumento(riproduzione.documentoRiproduzioneId)"></p-button>
            </td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
            <td class="col-w40"></td>
          }
        </tr>
      </ng-template>
    </p-table>
  `,
  styles: [`
    .col-w50 { width: 50px; text-align: center; }
    .col-w90 { width: 90px; text-align: center; }
    .col-w40 { width: 40px; text-align: center; }
    .col-w120 { width: 120px; text-align: center; }
    :host ::ng-deep .p-button.p-button-link {color:#0000EE; padding-left: 0px;}
    .circle {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-left: 10px;
      border-radius: 100%;
    }
  `]
})

export class RiproduzioniTableComponent {
  riproduzioni = input<DocumentoRiproduzioneRow[]>([]);
  trasmetti = output<DocumentoRiproduzioneRow>();
  spedisci = output<DocumentoRiproduzioneRow>();
  distruggiRipro = output<DocumentoRiproduzioneRow>();
  gestisciAllegatiRipro = output<DocumentoRiproduzioneRow>();
  modificaRipro = output<DocumentoRiproduzioneRow>();

  private confirmationService = inject(ConfirmationService);
  private router = inject(Router);

  public rowColor(row: DocumentoRiproduzioneRow): string {
    if (!row.documentoRiproduzioneId) return 'blue'
    else if (row.distrutto) return 'red'
    else if (row.trasmesso || row.spedito) return 'green'
    else return 'orange';
  }

  public trasmettiRiproduzione(ripro: DocumentoRiproduzioneRow): void {
    this.trasmetti.emit(ripro);
  }

  public spedisciRiproduzione(ripro: DocumentoRiproduzioneRow): void {
    this.spedisci.emit(ripro);
  }

  public distruggiRiproduzione(ripro: DocumentoRiproduzioneRow): void {
    this.confirmationService.confirm({
      header: 'Distruzione riproduzione',
      icon: 'fas fa-fw fa-trash',
      message: `La distruzione di una riproduzione provocherà la cancellazione di tutti gli allegati e bloccherà ogni modifica.
      <p>Sei sicuro di voler distruggere la riproduzione?</p>`,
      accept: () => {
        this.distruggiRipro.emit(ripro);
      }
    });
  }

  public gestisciAllegatiRipoduzione(ripro: DocumentoRiproduzioneRow): void {
    this.gestisciAllegatiRipro.emit(ripro);
  }

  public modificaRipoduzione(ripro: DocumentoRiproduzioneRow): void {
    this.modificaRipro.emit(ripro);
  }

  public vaiADocumento(docId: number): void {
    void this.router.navigateByUrl('/visualizza/' + docId.toString());
  }

}
